"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Interval = _interopRequireDefault(require("../interval/Interval"));

var _WireObject2 = _interopRequireDefault(require("../WireObject"));

var _isEmpty = _interopRequireDefault(require("../../utils/array/isEmpty"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _removeUnusedKeys = _interopRequireDefault(require("../../utils/object/removeUnusedKeys"));

var _CreativeDocumentModel = _interopRequireDefault(require("./CreativeDocumentModel"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * A model for the various properties we store on creatives
 */
var CreativeDocumentMetadata = /*#__PURE__*/function (_WireObject) {
  (0, _inherits2["default"])(CreativeDocumentMetadata, _WireObject);

  var _super = _createSuper(CreativeDocumentMetadata);

  function CreativeDocumentMetadata() {
    var _this;

    (0, _classCallCheck2["default"])(this, CreativeDocumentMetadata);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_outputRanges", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_skippedShotData", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_totalSourceVideosCount", void 0);
    return _this;
  }

  (0, _createClass2["default"])(CreativeDocumentMetadata, [{
    key: "copy",
    value: function copy() {
      var json = this.toJSON();
      return CreativeDocumentMetadata.fromJSON(json);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var outputRanges = null;

      if ((0, _isNotNil["default"])(this.outputRanges)) {
        // Output ranges are Intervals, convert them to JSON.
        outputRanges = (0, _toConsumableArray2["default"])(this.outputRanges).map(function (outputRange) {
          return outputRange.toJSON();
        });
      }

      var skippedShotData = null;

      if ((0, _isNotNil["default"])(this.skippedShotData)) {
        skippedShotData = this.skippedShotData.toJSON();
      }

      var metadataObj = {
        outputRanges: outputRanges,
        skippedShotData: skippedShotData,
        totalSourceVideosCount: this.totalSourceVideosCount
      };
      return (0, _removeUnusedKeys["default"])(metadataObj);
    }
  }, {
    key: "outputRanges",
    get: function get() {
      return this._outputRanges;
    },
    set: function set(outputRanges) {
      this._outputRanges = outputRanges;
    }
  }, {
    key: "skippedShotData",
    get: function get() {
      return this._skippedShotData;
    },
    set: function set(skippedShotData) {
      this._skippedShotData = skippedShotData;
    }
  }, {
    key: "totalSourceVideosCount",
    get: function get() {
      return this._totalSourceVideosCount;
    },
    set: function set(totalSourceVideosCount) {
      this._totalSourceVideosCount = totalSourceVideosCount;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inMetadata) {
      var outputRanges = inMetadata.outputRanges,
          skippedShotData = inMetadata.skippedShotData,
          totalSourceVideosCount = inMetadata.totalSourceVideosCount;
      var creativeDocumentMetadata = new CreativeDocumentMetadata();

      if (!(0, _isEmpty["default"])(outputRanges)) {
        creativeDocumentMetadata.outputRanges = outputRanges.reduce(function (allOutputRanges, outputRange) {
          allOutputRanges.add(_Interval["default"].fromJSON(outputRange));
          return allOutputRanges;
        }, new Set());
      }

      if ((0, _isNotNil["default"])(skippedShotData)) {
        creativeDocumentMetadata.skippedShotData = _CreativeDocumentModel["default"].fromJSON(skippedShotData);
      }

      if ((0, _isNumber["default"])(totalSourceVideosCount)) {
        creativeDocumentMetadata.totalSourceVideosCount = totalSourceVideosCount;
      }

      return creativeDocumentMetadata;
    }
    /**
     * Checks if object is an instance of CreativeDocumentMetadata
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isCreativeDocumentMetadata",
    value: function isCreativeDocumentMetadata(inputObject) {
      return inputObject instanceof CreativeDocumentMetadata;
    }
  }]);
  return CreativeDocumentMetadata;
}(_WireObject2["default"]);

exports["default"] = CreativeDocumentMetadata;